import { RadioGroup as MuiRadioGroup } from "@mui/material"

import React from "react"
import { RadioGroupProps } from "@/types/components/radioGroup"

import classnames from "classnames"

import "./radioGroup.scss"
import Radio from "@/components/form/radio/Radio"

export default function RadioGroup<T>({
  items,
  direction,
  onChange,
  labelKey = "label",
  valueKey = "value",
  disabled = false,
  label,
  ...props
}: RadioGroupProps<T>) {
  const getValue = (item: unknown) => {
    if (typeof item === "object") {
      return (item as Record<string, unknown>)[valueKey]
    }

    return item
  }

  const getLabel = (item: unknown) => {
    if (label && typeof label === "function") {
      return label(item as T)
    }

    if (label) {
      return label
    }

    if (typeof item === "object") {
      return (item as Record<string, unknown>)[labelKey] as React.ReactNode
    }

    return item as string
  }

  return (
    <MuiRadioGroup
      {...props}
      className={classnames("RadioGroupCont", props.className)}
      value={getValue(props.value)}
      onChange={onChange}
      row={direction === "row"}>
      {items.map((item, index) => (
        <Radio key={index} disabled={disabled} value={getValue(item)} label={getLabel(item)} />
      ))}
    </MuiRadioGroup>
  )
}
